import * as R from "ramda";

const indexjsFileRegExp = /index.js$/;
const propertiesFormContainerFileRegExg = /propertiesForm.vue$/;
const modulesFiles = require.context("./group", true);

export const groupInfoObj = {
  InputOutput: { name: "输入/输出", sortNo: 1 },
  FourBasicMathRules: { name: "算数运算符", sortNo: 2 },
  MathematicalLogic: { name: "逻辑运算符", sortNo: 3 },
  ComparisonSymbols: { name: "比较符", sortNo: 4 },
};

export const getStencils = () => {
  const tmp = {};
  R.map((modulePath) => {
    let modulePathArray = R.split("/", modulePath);
    modulePathArray = R.filter((str) => str !== ".", modulePathArray);
    if (
      modulePathArray.length === 3 &&
      indexjsFileRegExp.test(modulePathArray[2])
    ) {
      const stencil = modulePathArray[1];
      if (!tmp[modulesFiles(modulePath).default.group])
        tmp[modulesFiles(modulePath).default.group] = {};

      tmp[modulesFiles(modulePath).default.group][stencil] =
        modulesFiles(modulePath).default;
    }
  }, modulesFiles.keys());

  return tmp;
};

export const getPropertiesFormContainers = () => {
  const tmp = {};
  R.map((modulePath) => {
    let modulePathArray = R.split("/", modulePath);
    modulePathArray = R.filter((str) => str !== ".", modulePathArray);
    if (
      modulePathArray.length === 3 &&
      propertiesFormContainerFileRegExg.test(modulePathArray[2])
    ) {
      const moduleAndStencil = modulePathArray;
      tmp[moduleAndStencil[1]] = modulesFiles(modulePath).default;
    }
  }, modulesFiles.keys());

  return tmp;
};
